import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { fmtEUR, mediaUrl } from "@/lib/api";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";

export default function Cart() {
  const { cart, updateQty, removeItem, cartTotal } = useApp();
  const nav = useNavigate();
  const delivery = cart.length > 0 ? 5 : 0;

  if (cart.length === 0) {
    return (
      <div className="max-w-2xl mx-auto text-center py-20 px-6">
        <ShoppingBag size={48} className="mx-auto text-neutral-500 mb-4" />
        <div className="font-display text-3xl uppercase mb-2">Shporta është bosh</div>
        <div className="text-neutral-400 mb-6">Shto produkte për të vazhduar me porosinë</div>
        <Link to="/kategori" className="hg-btn-primary inline-block px-6 py-3 uppercase text-sm">Shfleto produktet</Link>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6">
      <h1 className="font-display text-3xl sm:text-4xl uppercase mb-6">Shporta</h1>
      <div className="grid md:grid-cols-[1fr_320px] gap-6">
        <div className="space-y-3">
          {cart.map(item => (
            <div key={item.key} data-testid={`cart-item-${item.key}`} className="hg-card p-3 flex gap-3">
              <div className="w-20 h-20 sm:w-24 sm:h-24 bg-[#131E30] flex-shrink-0 overflow-hidden">
                {item.image && <img src={mediaUrl(item.image)} alt="" className="w-full h-full object-cover" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium">{item.name}</div>
                {item.configuration && (
                  <div className="text-[11px] text-neutral-400 mt-1 space-y-0.5">
                    <div>Tubi: {item.configuration.hose}</div>
                    {item.configuration.ferrule && <div>Hylsa: {item.configuration.ferrule}</div>}
                    <div>Kop. A: {item.configuration.couplingA}</div>
                    <div>Kop. B: {item.configuration.couplingB}</div>
                    <div>Gjatësia: {item.configuration.length_m}m • {item.configuration.assembly ? "me montim" : "pa montim"}</div>
                  </div>
                )}
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center border border-[#1F2B44]">
                    <button onClick={() => updateQty(item.key, item.quantity - 1)} className="w-8 h-8 flex items-center justify-center"><Minus size={14} /></button>
                    <div className="w-8 text-center text-sm">{item.quantity}</div>
                    <button onClick={() => updateQty(item.key, item.quantity + 1)} className="w-8 h-8 flex items-center justify-center"><Plus size={14} /></button>
                  </div>
                  <div className="text-[#FFD600] font-bold">{fmtEUR(item.unit_price * item.quantity)}</div>
                </div>
              </div>
              <button onClick={() => removeItem(item.key)} data-testid={`remove-${item.key}`} className="text-neutral-500 hover:text-red-500 self-start p-1">
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>
        <div className="hg-card p-4 h-fit md:sticky md:top-20 space-y-3">
          <div className="font-display text-xl uppercase">Përmbledhja</div>
          <div className="flex justify-between text-sm"><span className="text-neutral-400">Nëntotali</span><span>{fmtEUR(cartTotal)}</span></div>
          <div className="flex justify-between text-sm"><span className="text-neutral-400">Dërgesa</span><span>{fmtEUR(delivery)}</span></div>
          <div className="flex justify-between font-display text-2xl pt-3 border-t border-[#1F2B44]"><span>Totali</span><span className="text-[#FFD600]">{fmtEUR(cartTotal + delivery)}</span></div>
          <button onClick={() => nav("/checkout")} data-testid="checkout-btn" className="hg-btn-primary w-full py-3 uppercase text-sm mt-2">Vazhdo në pagesë</button>
        </div>
      </div>
    </div>
  );
}
